import React from "react";
import styled from "styled-components";
import Action from '../../Action/components/Action';
import icons from '../../Icons/icons';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 10px;
  & > * {
    width: 90px;
  }
`;

export default function ActionsList({ actions , actionsColor , fontColor}) {
  return <Container>
       {
            actions ? actions.map((action) => (
            <Action
                fontColor={fontColor}
                color={actionsColor}
                key={action.position}
                text={action.description}
                icon={icons[action.icon]}
                link={action.link !== null &&  action.link !== undefined && action.link !== '' ? action.link : action.defaultLink}
                // onClick={action.type === 'share' ? () => setShareModalOpen(true) : null}
            />
            )) : null
        }
  </Container>;
}
